export const PageHero = ({ eyebrow, title, subtitle, accent, testId = "page-hero" }) => {
  return (
    <section
      className="relative pt-36 md:pt-44 pb-20 md:pb-28 border-b border-[#27272a] overflow-hidden"
      data-testid={testId}
    >
      {/* Background geometric accents */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-20 w-[500px] h-[500px] rounded-full bg-[#f59e0b]/5 blur-3xl" />
        <div className="absolute top-40 left-1/3 w-px h-40 bg-[#f59e0b]/40" />
        <div className="absolute bottom-10 right-1/4 w-40 h-px bg-[#f59e0b]/40" />
      </div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 relative">
        <div className="label-sm text-[#f59e0b] mb-6 animate-fade-up">
          {eyebrow}
        </div>
        <h1 className="font-display font-black text-5xl sm:text-7xl md:text-8xl uppercase leading-[0.85] max-w-5xl animate-fade-up">
          {title}
          {accent && (
            <>
              <br />
              <span className="text-[#f59e0b]">{accent}</span>
            </>
          )}
        </h1>
        {subtitle && (
          <p className="mt-8 text-lg md:text-xl text-[#a1a1aa] max-w-2xl leading-relaxed animate-fade-up">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};
